import { api } from '../../../utils/api.ts';

export const useDetailQuoteOrder = ({ transactionId }: { transactionId: string }) => {
    return api.platoUser.grid.getDetailQuoteOrder.get.useQuery(
        {
            id: transactionId,
        },
        {
            refetchOnMount: false,
        },
    );
};
